export const FAMILY_PROPERTY = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产综合保险条款',
    protocols: [
        {
            intro: '总则',
            list: [
                {
                    order: '第一条',
                    context: '本保险合同由保险条款、投保单、保险单、批单及其附件组成。凡涉及本保险合同的约定，均应采用书面形式。'
                }
            ]
        },
        {
            intro: '保险标的',
            list: [
                {
                    order: '第二条',
                    context: '凡是被保险人自有的，座落于本保险单所载明地址内的下列家庭财产，可包括在本保险合同的保险标的范围以内：',
                    details: [
                        { text: '一、房屋及其室内附属设备（如固定装置的水暖、气暖、卫生、供水、管道煤气及供电设备、厨房配套的设备等）；' },
                        { text: '二、室内财产：', regulations: [
                            '（一）家用电器和文体娱乐用品；',
                            '（二）衣物和床上用品；',
                            '（三）室内装潢、家具及其他生活用具。'
                        ] }
                    ]
                },
                {
                    order: '第三条',
                    context: '下列财产经被保险人与保险人特别约定，并在保险单上载明，可在本保险合同的保险标的范围以内：',
                    details: [
                        { text: '一、属于被保险人代他人保管或者与他人共有而由被保险人负责的第二条载明的财产；' },
                        { text: '二、存放于院内、室内的非机动农机具、农用工具及存放于室内的粮食及农副产品；' },
                        { text: '三、经保险人同意的其他财产。' }
                    ]
                },
                {
                    order: '第四条',
                    context: '下列家庭财产不在保险标的范围以内：',
                    details: [
                        { text: '一、金银、珠宝、钻石及制品、玉器、首饰、古币、古玩、字画、邮票、艺术品、稀有金属等珍贵财物；' },
                        { text: '二、货币、票证、有价证券、有现金价值的磁卡、文件、书籍、帐册、图表、技术资料、电脑软件及资料、以及无法鉴定价值的财产；' },
                        { text: '三、日用消耗品、各种交通工具、养殖及种植物；' },
                        { text: '四、用于从事工商业生产、经营活动的财产和出租用作工商业的房屋；' },
                        { text: '五、便携式通讯装置、便携式计算机设备、便携式照相摄像器材、笔、打火机、手表，各种磁带、磁盘、影音激光盘；' },
                        { text: '六、用芦席、稻草、油毛毡、麦杆、芦苇、竹竿、帆布、塑料布、纸板等为外墙、屋顶的简陋屋棚及柴房、禽畜棚、与保险房屋不成一体的厕所、围墙、无人居住的房屋以及存放在里面的财产；' },
                        { text: '七、政府有关部门征用、占用的房屋，违章建筑、危险建筑、非法占用的财产、处于危险状态下的财产；' },
                        { text: '八、其他不属于第二条、第三条所列明的家庭财产。' }
                    ]
                }
            ]
        },
        {
            intro: '保险责任',
            list: [
                {
                    order: '第五条',
                    context: '在保险期间内，由于下列原因造成保险标的的损失，保险人依照本保险合同的约定负责赔偿：',
                    details: [
                        { text: '一、火灾、爆炸；' },
                        { text: '二、雷击、台风、龙卷风、暴风、暴雨、洪水、雪灾、雹灾、冰凌、泥石流、崖崩、突发性滑坡、地面突然下陷；' },
                        { text: '三、飞行物体及其他空中运行物体坠落，外来不属于被保险人所有或使用的建筑物和其他固定物体的倒塌。' }
                    ]
                },
                {
                    order: '第六条',
                    context: '被保险人的下列损失和费用，保险人依照本保险合同的约定也负责赔偿：',
                    details: [
                        { text: '一、发生保险事故时，为抢救保险标的或防止灾害蔓延，采取合理的、必要的措施而造成保险标的的损失。' },
                        { text: '二、保险事故发生后，为防止或者减少保险标的的损失所支付的必要的、合理的费用。' }
                    ]
                }
            ]
        },
        {
            intro: '责任免除',
            list: [
                {
                    order: '第七条',
                    context: '由于下列原因造成保险标的的损失，保险人不负责赔偿：',
                    details: [
                        { text: '一、战争、敌对行为、军事行动、武装冲突、罢工、暴动、骚乱和恐怖活动；' },
                        { text: '二、核反应、核子辐射和放射性污染；' },
                        { text: '三、被保险人及其家庭成员、寄居人、雇佣人员的违法、犯罪或故意行为；' },
                        { text: '四、地震及其次生灾害；' },
                        { text: '五、盗窃、抢劫；' },
                        { text: '六、行政行为和执法行为。' }
                    ]
                },
                {
                    order: '第八条',
                    context: '保险人对下列损失和费用也不负责赔偿：',
                    details: [
                        { text: '一、保险标的遭受保险事故引起的各种间接损失；' },
                        { text: '二、家用电器因使用过度、超电压、短路、断路、漏电、自身发热、烘烤等原因所造成本身的损毁；' },
                        { text: '三、座落在蓄洪区、行洪区，或在江河岸边、低洼地区以及防洪堤以外当地常年警戒水位线以下的家庭财产，由于洪水所造成的一切损失；' },
                        { text: '四、保险标的本身缺陷、保管不善导致的损毁；保险标的的变质、霉烂、受潮、虫咬、自然磨损、自然损耗、自燃、烘焙所造成本身的损失；' },
                        { text: '五、本保险合同中规定的应由被保险人自行负担的免赔额；' },
                        { text: '六、其他不属于保险责任范围内的损失和费用。' }
                    ]
                }
            ]
        },
        {
            intro: '保险价值、保险金额与免赔额（率）',
            list: [
                { order: '第九条', context: '房屋及室内附属设备的保险价值为出险时的重置价值。' },
                {
                    order: '第十条',
                    context: '房屋及室内附属设备的保险金额由投保人根据购置价或市场价自行确定。',
                    details: [
                        { text: '室内财产的保险金额由投保人根据当时实际价值分项目自行确定。不分项目的，按各大类财产在保险金额中所占比例确定，即室内财产中的家用电器及文体娱乐用品占40%（农村30%），衣物及床上用品占30%（农村15%），室内装潢、家具及其他生活用具占30%，农村农机具等占25%。' },
                        { text: '特约财产的保险金额由投保人和保险人双方约定。' },
                        { text: '保险金额不得超过保险价值。超过保险价值的，超过部分无效，保险人应当退还相应的保险费。' }
                    ]
                },
                { order: '第十一条', context: '免赔额（率）由投保人与保险人在订立本保险合同时协商确定，并在本保险合同中载明。' }
            ]
        },
        {
            intro: '保险期间',
            list: [
                { order: '第十二条', context: '除另有约定外，保险期间为一年，以保险单载明的起讫时间为准。' }
            ]
        },
        {
            intro: '保险人义务',
            list: [
                { order: '第十三条', context: '本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。' },
                { order: '第十四条', context: '保险人按照第二十二条的约定，认为被保险人提供的有关索赔的证明和资料不完整的，应当及时一次性通知投保人、被保险人补充提供。' },
                { order: '第十五条', context: '保险人收到被保险人的赔偿保险金的请求后，应当及时作出是否属于保险责任的核定；情形复杂的，应当在三十日内作出核定，但被保险人未提供必要核定依据的除外。', details: [ { text: '保险人应当将核定结果通知被保险人；对属于保险责任的，在与被保险人达成赔偿保险金的协议后十日内，履行赔偿保险金义务。本保险合同对赔偿保险金的期限有约定的，保险人应当按照约定履行赔偿保险金的义务。保险人依照前款约定作出核定后，对不属于保险责任的，应当自作出核定之日起三日内向被保险人发出拒绝赔偿保险金通知书，并说明理由。' } ] },
                { order: '第十六条', context: '保险人自收到赔偿保险金的请求和有关证明、资料之日起六十日内，对其赔偿保险金的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支付；保险人最终确定赔偿的数额后，应当支付相应的差额。' }
            ]
        },
        {
            intro: '投保人、被保险人义务',
            list: [
                {
                    order: '第十七条',
                    context: '订立本保险合同，保险人就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。',
                    details: [
                        { text: '投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本保险合同。' },
                        { text: '投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，并不退还保险费。' },
                        { text: '投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，但应当退还保险费。' }
                    ]
                },
                {
                    order: '第十八条',
                    context: '除另有约定外，投保人应在本保险合同成立时交清保险费。',
                    details: [ { text: '投保人未按照本保险合同的约定及时足额交付保险费的，保险人可解除本保险合同，本保险合同自保险人解除本保险合同的书面通知送达投保人时解除，保险人有权向投保人收取自保险责任开始时至本保险合同解除时期间的保险费。保险人对于合同解除前发生的保险事故，按照保险事故发生时投保人已交保险费与本保险合同约定应交保险费的比例承担赔偿保险金的责任。' } ]
                },
                { order: '第十九条', context: '被保险人应当遵照国家有关消防、安全方面的规定，尽力避免或减少责任事故的发生，维护保险标的的安全。' },
                { order: '第二十条', context: '在保险期间内，如被保险人的地址发生变更或保险标的的所有权发生转移，应当及时通知保险人，并根据保险人的有关规定办理批改手续。', details: [
                    { text: '因上述变化导致危险程度显著增加的，保险人自收到前款规定的通知之日起三十日内，可以增加保险费或者解除合同。' },
                    { text: '被保险人、受让人未履行本条规定的通知义务的，因上述变化导致保险标的危险程度显著增加而发生的保险事故，保险人不承担赔偿保险金的责任。' }
                ] },
                {
                    order: '第二十一条',
                    context: '发生本保险责任范围内的事故时，被保险人应该：',
                    details: [
                        { text: '（一）尽力采取必要、合理的措施，防止或减少损失，否则，对因此扩大的损失，保险人不承担赔偿责任；' },
                        { text: '（二）及时通知保险人，并书面说明事故发生的原因、经过和损失情况；故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担赔偿保险金的责任，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。' },
                        { text: '（三）保护事故现场，允许并且协助保险人进行事故调查。' }
                    ]
                },
                {
                    order: '第二十二条',
                    context: '被保险人请求赔偿时，应向保险人提供保险单、财产损失清单、发票、费用单据和有关部门的证明。',
                    details: [ { text: '被保险人未履行前款约定的索赔材料提供义务，导致保险人无法核实损失情况的，保险人对无法核实的部分不承担赔偿责任。' } ]
                }
            ]
        },
        {
            intro: '赔偿处理',
            list: [
                { order: '第二十三条', context: '保险事故发生时，被保险人对保险标的不具有保险利益的，不得向保险人请求赔偿保险金。' },
                {
                    order: '第二十四条',
                    context: '保险事故发生后，保险人按照下列方式计算赔偿：',
                    details: [
                        {
                            text: '一、房屋及室内附属设备：',
                            regulations: [
                                '（一）全部损失',
                                '保险金额等于或高于保险价值时，其赔偿金额以不超过保险价值为限；保险金额低于保险价值时，按保险金额赔偿。',
                                '（二）部分损失',
                                '保险金额等于或高于保险价值时，按实际损失计算赔偿金额；保险金额低于保险价值时，应根据实际损失或恢复原状所需修复费用乘以保险金额与保险价值的比例计算赔偿金额。'
                            ]
                        },
                        {
                            text: '二、室内财产的赔偿计算：',
                            regulations: [ '全部损失和部分损失，在分项目保险金额内，按实际损失赔付。' ]
                        },
                        {
                            text: '三、特约承保财产的赔偿计算：',
                            regulations: [ '参照本条第一、二款执行。' ]
                        },
                        { text: '四、被保险人所支付的必要、合理的施救费用,按实际支出另行计算，最高不超过受损标的的保险金额。若该保险标的按比例赔偿时，则该项费用也按相同的比例赔偿。' }
                    ]
                },
                { order: '第二十五条', context: '保险标的遭受损失后，如果有残余价值，应由双方协商处理。如折归被保险人，由双方协商确定其价值，并在保险赔款中扣除。' },
                { order: '第二十六条', context: '保险事故发生时，如果存在重复保险，保险人按照本保险合同的相应保险金额与其他保险合同及本保险合同相应保险金额总和的比例承担赔偿责任。', details: [ { text: '其他保险人应承担的赔偿金额，本保险人不负责垫付。若被保险人未如实告知导致保险人多支付赔偿金的，保险人有权向被保险人追回多支付的部分。' } ] },
                { order: '第二十七条', context: '保险标的发生部分损失，保险人履行赔偿义务后，本保险合同的保险金额自损失发生之日起按保险人的赔偿金额相应减少，保险人不退还保险金额减少部分的保险费。如投保人请求恢复至原保险金额，应按原约定的保险费率另行支付恢复部分从投保人请求的恢复日期起至保险期间届满之日止按日比例计算的保险费。' },
                { order: '第二十八条', context: '发生保险责任范围内的损失，应由有关责任方负责赔偿的，保险人自向被保险人赔偿保险金之日起，在赔偿金额范围内代位行使被保险人对有关责任方请求赔偿的权利，被保险人应当向保险人提供必要的文件和所知道的有关情况。', details: [
                    { text: '被保险人已经从有关责任方取得赔偿的，保险人赔偿保险金时，可以相应扣减被保险人已从有关责任方取得的赔偿金额。' },
                    { text: '保险事故发生后，在保险人未赔偿保险金之前，被保险人放弃对有关责任方请求赔偿权利的，保险人不承担赔偿责任；保险人向被保险人赔偿保险金后，被保险人未经保险人同意放弃对有关责任方请求赔偿权利的，该行为无效；由于被保险人故意或者因重大过失致使保险人不能行使代位请求赔偿的权利的，保险人可以扣减或者要求返还相应的保险金。' }
                ] },
                { order: '第二十九条', context: '被保险人向保险人请求赔偿保险金的诉讼时效期间为二年，自其知道或者应当知道保险事故发生之日起计算。' }
            ]
        },
        {
            intro: '争议处理及法律适用',
            list: [
                { order: '第三十条', context: '因履行本保险合同发生的争议，由当事人协商解决；协商不成的，可提交本保险合同载明的仲裁机构仲裁；本保险合同未载明仲裁机构或者争议发生后未达成仲裁协议的，可依法向人民法院起诉。' },
                { order: '第三十条', context: '与本保险合同有关的以及履行本保险合同产生的一切争议，适用中华人民共和国法律（不包括港澳台地区法律）。' }
            ]
        },
        {
            intro: '其他事项',
            list: [
                { order: '第三十二条', context: '在保险期间内，投保人可以书面形式提出变更本保险合同的有关内容。保险人同意更改、出具批单后，批改生效。' },
                { order: '第三十三条', context: '保险责任开始前，投保人要求解除合同的，应当按照合同约定向保险人支付手续费，保险人应当退还保险费。', details: [ { text: '保险责任开始后，投保人要求解除本保险合同的，自通知保险人之日起，本保险合同解除，保险人按短期费率计收自保险责任开始之日起至合同解除之日止期间的保险费，并退还剩余部分保险费。' } ] },
                { order: '第三十四条', context: '保险标的发生全部损失，属于保险责任的，保险人在履行赔偿义务后，本保险合同终止；不属于保险责任的，本保险合同终止，保险人按短期费率计收自保险责任开始之日起至损失发生之日止期间的保险费，并退还剩余部分保险费。', details: [ { text: '保险标的发生部分损失，在保险人赔偿后三十日内，保险人可以解除本保险合同。保险人解除本保险合同的，应当提前十五日通知投保人，并将保险标的未受损失部分的保险费，扣除自保险责任开始之日起至合同解除之日止期间的应收部分后，退还投保人。' } ] }
            ]
        },
        {
            intro: '释义',
            list: [
                {
                    order: '第三十五条',
                    context: '本保险合同涉及术语适用下列释义：',
                    details: [
                        { text: '（一）暴雨：指每小时降雨量达16毫米以上，或连续12小时降雨量达30毫米以上，或连续24小时降雨量达50毫米以上的降雨。' },
                        { text: '（二）台风：指中心附近最大平均风力12级或以上，即风速在32.6米/秒以上的热带气旋。' },
                        { text: '（三）暴风：指风力达8级、风速在17.2米/秒以上的自然风。' },
                        { text: '（四）龙卷风：指一种范围小而时间短的猛烈旋风，陆地上平均最大风速在79米/秒-103米/秒，极端最大风速在100米/秒以上。' },
                        { text: '（五）重置价值：指替换、重建受损保险标的，以使其达到事故发生时的状态而发生的费用，但不包括被保险人进行的任何变更、性能增加或改进所产生的额外费用。' }
                    ]
                }
            ]
        }
    ],
    appendix: {
        intro: '短期费率按月比例或日比例计算，其中月比例短期费率表如下：',
        annotation: '注：不足一个月的部分按一个月计算。',
        table: [
            ['保险期间（月）', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
            ['年费率的百分比', '10', '20', '30', '40', '50', '60', '70', '80', '85', '90', '95', '100']
        ]
    }   
}